<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>concact</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">concact</div>
      </div>
    </div>

    <div class="layout-content" style="padding:40px;min-height: 500px;">
      <div v-html="info.text" v-if="info"></div>
      <div class="u-empty" v-else>no data</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      info: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      exhibition: 'loginModule/getExhibition',
    }),
  },
  methods: {
    ...mapActions({
      getExhibitionLinkByExId: "registerdModule/getExhibitionLinkByExId",
    }),
    async getExhibitionLinkHandle () {
      let res = await this.getExhibitionLinkByExId(this.exhibition.id);
      if (res) {
        this.info = res;
      }
      console.log('getExhibitionLinkHandle', res);
    },
  },
  created () {
    this.getExhibitionLinkHandle();

  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
</style>
